import styles from '../App.module.css'

export default function ButtonDownload() {
    function LinkDownloadAndroid() {
        window.open('https://www.youtube.com/', '_blank');
    }


    function LinkDownloadApple() {
        window.open('https://www.youtube.com/', '_blank');

    }
    return (
        <ul className={styles.direcionar}>
        <a className={styles.containerDownloadA}>

            <img className={styles.downloadIcon} src='https://www.gov.br/pt-br/imagens-de-servicos/googleplay.png/@@images/image' alt='Android' onClick={LinkDownloadAndroid} />
           

        </a>
        <a className={styles.containerDownloadB}>
             <img className={styles.downloadIcon} src='https://www.gov.br/pt-br/imagens-de-servicos/apple.png' alt='Apple' onClick={LinkDownloadApple} />
        </a>
        </ul>
    )
}